// extracted by mini-css-extract-plugin
export default {"root":"Header_root__qxV-w","contacts":"Header_contacts__eOLvg","nav":"Header_nav__ReCtG","logo":"Header_logo__pEndU"};